
import Vue from 'vue'
import { VBadge } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcBadge',
  components: {
    VBadge,
  },
  props: {
    color: {
      type: String,
      default: undefined,
    },
    offset: {
      type: Boolean,
      default: false,
    },
    content: {
      type: [String, Number],
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },
})
